import React, { useEffect, useState } from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { Button, Container, Table } from "react-bootstrap";
import {
  APP_CONST,
  DefaultDateFormat,
  PaymentAccountType,
} from "../../../../config/const";
import usePaginationHook from "../../../../hooks/usePaginationHook";
import useTxnFilterHook from "../../../../hooks/useTxnFilterHook";
// import TxnFilters from "../../../components/Transactions/Filters";
import dayjs from "dayjs";
import QueryString from "qs";
import {
  detelePlayerBankRecord,
  getPaymentAccoutSettings,
  getSavedPaymentAccounts,
} from "../../../../redux/user/actions";

import BackIcon from "../../../../assets/svg/BackIcon";
import { useNavigate } from "react-router-dom";
import { AppLoader } from "../../../components/Ui/AppLoader";
import { MdDeleteForever } from "react-icons/md";
import PaymentAccountBank from "../../../components/PaymentAccount/PaymentAccountBank";
import PaginationCardNew from "../../../components/PaginationCardNew";
import { Toaster } from "../../../../utils/toaster";
import PaymentAccountOtp from "../../../components/PaymentAccount/PaymentAccountOtp";
import Footer from "../../../../containers/Footer";

const PaymentAccount = () => {
  const pagination = usePaginationHook();
  const navigate = useNavigate();
  const filtersHook = useTxnFilterHook({
    from: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
    to: dayjs().add(1, "day").format("YYYY-MM-DD"),
  });
  const [paymentAccounts, setPaymentAccounts] = useState({
    count: 0,
    pagesize: 15,
    results: [],
  });
  const [isFetching, setIsFetching] = useState(false);
  const [showAddBankModal, setShowAddBankModal] = useState(false);
  const [paymentAccOtpConfig, setPaymentAccOtpConfig] = useState({
    otpValue: null,
    isOtpSent: false,
    isotpRequired: false,
    showOtpModal: false,
  });

  useEffect(() => {
    fetchPaymentAccSettings();
  }, []);

  useEffect(() => {
    fetchPaymentAccounts();
  }, [
    filtersHook.filters.from,
    filtersHook.filters.to,
    pagination.apiParams.pagesize,
    pagination.apiParams?.skip,
  ]);

  const fetchPaymentAccounts = async () => {
    const object = {
      startdate: new Date(filtersHook.filters.from),
      enddate: new Date(filtersHook.filters.to),
      type: PaymentAccountType.Bank,
      pagesize: pagination.apiParams?.pagesize,
      skip: pagination.apiParams?.skip,
    };
    const query = QueryString.stringify(object);
    setIsFetching(true);
    const response = await getSavedPaymentAccounts(query);
    setIsFetching(false);
    if (response && "data" in response) {
      setPaymentAccounts(response?.data?.data);
    }
  };

  const handleAccountDelete = async (id = null) => {
    if (!id) {
      return;
    }

    const confirm = window.confirm("Delete account?");
    if (!confirm) {
      return;
    }

    const response = await detelePlayerBankRecord(id);

    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Payment account deleted");
      fetchPaymentAccounts();
    }
  };

  const fetchPaymentAccSettings = async () => {
    const response = await getPaymentAccoutSettings();

    if (response && "data" in response) {
      setPaymentAccOtpConfig((p) => ({
        ...p,
        isotpRequired: response?.data?.payment_account?.otp_validation === true,
      }));
    }
  };

  const handleAddBankClick = () => {
    if (paymentAccOtpConfig.isotpRequired === true) {
      setPaymentAccOtpConfig((p) => ({ ...p, showOtpModal: true }));
      return;
    }
    setShowAddBankModal(true);
  };

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <Container>
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Payment Accounts</h2>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>
          <div className="transaction-details">
            <div className="data-info">
              <div className="d-flex justify-content-between align-items-center FilterContainer">
                {/* <TxnFilters
                  filtersHook={filtersHook}
                  showSearch={false}
                  resetValues={{
                    from: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
                    to: dayjs().add(1, "day").format("YYYY-MM-DD"),
                  }}
                /> */}
                <div className="d-flex justify-content-end add-bank-detail">
                  <Button onClick={handleAddBankClick}>+ Add Bank</Button>
                </div>
              </div>
              {isFetching ? (
                <AppLoader text={"Fetching payment accounts"} />
              ) : paymentAccounts?.results?.length > 0 ? (
                <div className="table-responsive table-wrapper">
                  <Table
                    responsive
                    borderless
                    className="custom-table align-middle"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Account Name</th>
                        <th>Account Number</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {paymentAccounts?.results?.map((account, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{account?.name || "-"}</td>
                          <td className="status">{account?.hint}</td>
                          <td>
                            {dayjs(account?.createdAt).format(
                              DefaultDateFormat,
                            )}
                          </td>
                          <td>
                            <MdDeleteForever
                              size={20}
                              color="red"
                              role="button"
                              onClick={() => handleAccountDelete(account?.id)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="d-flex justify-content-center">
                  Nothing here just yet — your payment accounts will appear here
                  once available
                </div>
              )}
            </div>

            <div className="border-t px-3 pb-5 mb-3">
              <PaginationCardNew
                pagination={pagination}
                count={paymentAccounts.count}
              />
            </div>
          </div>

          {paymentAccOtpConfig.showOtpModal && (
            <PaymentAccountOtp
              onSubmit={(otp) => {
                setPaymentAccOtpConfig((p) => ({
                  ...p,
                  otpValue: otp,
                  showOtpModal: false,
                }));
                setShowAddBankModal(true);
              }}
              paymentAccOtpConfig={paymentAccOtpConfig}
              handleClose={() =>
                setPaymentAccOtpConfig((p) => ({ ...p, showOtpModal: false }))
              }
            />
          )}
          {showAddBankModal && (
            <PaymentAccountBank
              show={showAddBankModal}
              handleClose={() => setShowAddBankModal(false)}
              fetchPaymentAccounts={fetchPaymentAccounts}
              paymentAccOtpConfig={paymentAccOtpConfig}
            />
          )}
        </Container>
      </main>

      <Footer />
    </>
  );
};

export default PaymentAccount;
